"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/queries/index.ts
var queries_exports = {};
__export(queries_exports, {
  ApiError: () => ApiError,
  QueryError: () => QueryError,
  isApiError: () => isApiError,
  queryClient: () => queryClient
});
module.exports = __toCommonJS(queries_exports);

// src/queries/queryClient.tsx
var import_react_query = require("@tanstack/react-query");

// src/queries/queryError.ts
var QueryError = class extends Error {
  constructor(apiError, message) {
    super(message ?? apiError);
    this.name = "QueryError";
    this.apiError = apiError;
  }
};
var ApiError = /* @__PURE__ */ ((ApiError2) => {
  ApiError2["FORBIDDEN"] = "FORBIDDEN";
  ApiError2["NOT_FOUND"] = "NOT_FOUND";
  ApiError2["UNAUTHORIZED"] = "UNAUTHORIZED";
  ApiError2["DESIGN_IS_DELETED"] = "DESIGN_IS_DELETED";
  ApiError2["INVALID_PARAMETERS"] = "INVALID_PARAMETERS";
  return ApiError2;
})(ApiError || {});
var apiErrorKeySet = new Set(Object.values(ApiError));
var isApiError = (error) => {
  return apiErrorKeySet.has(error);
};

// src/queries/queryClient.tsx
var queryClient = new import_react_query.QueryClient({
  defaultOptions: {
    queries: {
      // for now I am setting the default staleTime to infinity because we don't currently rerun get queries anyway
      // so its 1 less thing to worry about on a per query basis
      staleTime: Infinity,
      gcTime: Infinity,
      retry: (_, res) => {
        if (res instanceof QueryError) {
          return false;
        }
        if ("error" in res && typeof res.error === "string" && isApiError(res.error)) {
          return false;
        }
        return true;
      }
    }
  }
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ApiError,
  QueryError,
  isApiError,
  queryClient
});
